import {Container, Row, Col} from "react-bootstrap";
import {useState, useEffect} from "react";
import {ReactTyped} from "react-typed";
import bannerIcon from '../assets/banner-icon.png';
import pierImg from '../assets/pier.JPG';
import {Link, animateScroll as scroll} from "react-scroll";
import React from 'react';

export const Banner = () => {
    const characteristics = ["software engineer", "ai/ml/hri researcher", "cybersecurity engineer", "drone pilot", "photographer"];

    const scrollToFooter = () => {
        document.getElementById('footer').scrollIntoView({ behavior: 'smooth' });
    };


    
    return (
        <React.Fragment>
        <section className="banner" id="home">
            <Container fluid className="banner-container">
                <div className="banner-inner">
                    <Row className="align-items-center">
                        <Col xs={12} md={7}>
                            <h1>{"hi, i'm shannon\n"}<br/></h1>
                            <h2>&#62; <span className="wrap"><ReactTyped
                                strings={characteristics}
                                typeSpeed={100}
                                loop
                                backSpeed={75}
                                cursorChar="|"
                                showCursor={true}/>
                                </span></h2>
                            <br/>
                            <p className="hero-description">
                                I'm a computer science student at Cornell Engineering passionate about building innovative solutions across software engineering, machine learning, and cybersecurity.
                            </p>
                            <p className="hero-description mt-3" style={{ fontSize: '13px' }}>
                                When I'm not coding, you can find me hiking 🥾, rock climbing 🧗‍♀️, skiing ⛷️, kayaking 🚣‍♀️, doing anything outdoors 🏔️, working on honing my photography 📸, videography 🎥, and drone flying skills 🛸, or playing with new tech 🤖!
                            </p>
                            <div className="button-container mt-4">
                                <button onClick={scrollToFooter}>Let's Connect</button>
                            </div>
                        </Col>
                        <Col xs={12} md={5} className="text-center mt-5 mt-md-0">
                            <img src={pierImg} alt="Shannon" className="hero-img"/>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
        </React.Fragment>
    );
}